// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ad876be","676":"e24f50fb"}[chunkId] + ".chunk.js";
};